// [sc-49170] Va a capo in un indirizzo senza spezzarne le parti.
// Se non sta su una riga, la prima interruzione è dopo il civico: via e
// civico sopra, città/CAP/provincia sotto («Via X n°42» / «Bronte 95034 (CT)»).
// Ogni metà che ancora non ci sta va a capo come sotto.
// Civico: numero breve, anche con «n°»/«n.», lettera o barra (42, n°42, 12/A);
// un numero di 5 cifre è il CAP, non il civico.
const CIVICO = /^(n[°º.]?)?\d{1,4}[a-z]?(\/\w+)?,?$/i;
const CAP = /^\d{5},?$/;

export function wrapAddress(text, maxWidth, measure) {
  const value = String(text).trim();
  if (measure(value) <= maxWidth) return [value];
  const words = value.split(/\s+/);
  const civico = words.findIndex((w, i) => i > 0 && CIVICO.test(w));
  if (civico < 0 || civico === words.length - 1) {
    return wrapParts(value, maxWidth, measure);
  }
  const via = words.slice(0, civico + 1).join(" ");
  const resto = words.slice(civico + 1).join(" ");
  return [
    ...wrapParts(via, maxWidth, measure),
    ...wrapParts(resto, maxWidth, measure),
  ];
}

// Le parti sono i pezzi separati da virgola («Via X, 42, 95034 Bronte CT»):
// una riga ne contiene quante ci stanno, e si va a capo solo fra una parte e
// l'altra. Una parte più larga della riga si divide fra le parole, tenendo
// attaccato alla parola prima ogni pezzo che comincia con una cifra
// (civico, CAP), così «Catena 42» e «Bronte 95034» non si separano.
// `measure` restituisce la larghezza di un testo (in jsPDF: doc.getTextWidth).
function wrapParts(text, maxWidth, measure) {
  const parts = String(text)
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);
  const lines = [];
  let current = "";
  parts.forEach((part, i) => {
    const piece = i < parts.length - 1 ? `${part},` : part;
    const joined = current ? `${current} ${piece}` : piece;
    if (measure(joined) <= maxWidth) {
      current = joined;
      return;
    }
    if (current) lines.push(current);
    if (measure(piece) <= maxWidth) {
      current = piece;
      return;
    }
    // Parte troppo lunga: si divide fra gruppi di parole. Il CAP seguito da
    // una parola si attacca a quella («95034 Bronte»), ogni altro numero
    // alla parola prima («Catena 42», «Bronte 95034»).
    const groups = [];
    let glueNext = false;
    piece.split(/\s+/).forEach((word, j, words) => {
      if (glueNext) {
        groups[groups.length - 1] += ` ${word}`;
        glueNext = false;
      } else if (
        CAP.test(word) &&
        j < words.length - 1 &&
        !/^\d/.test(words[j + 1])
      ) {
        groups.push(word);
        glueNext = true;
      } else if (groups.length && /^\d/.test(word)) {
        groups[groups.length - 1] += ` ${word}`;
      } else {
        groups.push(word);
      }
    });
    current = "";
    groups.forEach((g) => {
      const next = current ? `${current} ${g}` : g;
      if (current && measure(next) > maxWidth) {
        lines.push(current);
        current = g;
      } else {
        current = next;
      }
    });
  });
  if (current) lines.push(current);
  return lines.length ? lines : [String(text)];
}
